<script>
import {Form, Field, ErrorMessage} from 'vee-validate';
import router from '@/router';
import axios from 'axios';
import PageLoader from '../components/Loader'

export default {
  data() {
    return {
      phone: "",
      isloading: false,
      errorMessage:""
    }
  },
  components: {
    Form,
    Field,
    ErrorMessage,
    PageLoader
  },
  methods: {
    loginHandle() {
      this.isloading = true;
      axios
          .get(process.env.VUE_APP_ROOT_API+'/api/login?phone=' + this.phone)
          .then(response => {
            this.isloading = false
            this.messages = response.data
            if (this.messages.status == "OTP") {
              localStorage.phone = this.phone
              router.push("/InsertCode")
            } else {
              this.errorMessage = this.messages.message
            }
          })
          .catch(err => {
            this.isloading = false
            this.errorMessage = err.response.data.message
          })
    },
    isRequired(value) {
      if (value && value.trim()) {
        return true;
      }
      return 'لطفا شماره تلفن خود را وارد نمایید';
    },
  },
}
</script>
<template>
  <PageLoader v-if="isloading"/>
  <h1 class="">ثبت نام اولیه سامانه</h1>
  <div class="m-3">
    <p>
                    <span class="d-block pb-3">
                     ضمن عرض خوش آمد گویی؛
                  </span>
      امکان ثبت نام صرفا برای افرادی که از طریق شبکه معرفین دعوت شده اند و شماره تلفن همراه ایشان ثبت شده باشد امکان پذیر است. لذا در صورت عدم دریافت کد تایید ورود، به معرف خود مراجعه فرمایید.     </p>
    <span class="text-danger mx-auto"><b>{{ errorMessage }}</b></span>
    <h1 class="my-3">تایید شماره موبایل</h1>
    <Form @submit="onSubmit"   >
      <Field  @keypress.prevent.enter="loginHandle" type="number" class="form-control" v-model="phone" name="reagent_phone"
             placeholder="شماره موبایل" :rules="isRequired"/>
      <ErrorMessage name="reagent_phone"/>
    </Form>
  </div>
  <br>
  <!--<RouterLink :to="{path:'/InsertCode' , query:{phone: this.phone}}">
    <button @click="loginHandle"  class="bbot mx-auto">دریافت کد تایید</button>
  </RouterLink>-->
  <div class="row">
    <div class="col-12 text-center">
      <button @click="loginHandle" class="btn btn-success">دریافت کد تایید</button>
    </div>
  </div>
</template>
<style>
.intro-text {
  font-family: Calibri, sans-serif;
}
</style>

